import React, { useEffect, useState } from "react";
import { Card, Form, Row, Col, Image, Table } from "react-bootstrap";
import FederalEmployeeCostModal from "../../modal/federalEmployee-cost";
import {
  formatCalculatedValue,
  convertValue,
  roundUpToNextThousand,
  formatValue,
  get_cost_of_option_a,
  get_cost_of_option_c_b,
  get_cost_of_option_b,
  get_cost_of_option_a_m,
  get_cost_of_option_c,
  get_cost_of_option_b_m,
} from "../../../services/helperService";
import Images from "../../CRMs/crm2.0";
import moment from "moment";
import { usePlannerContext } from "../../../contexts/planner.contexts";

const FegliForm = ({ validated, submit }) => {
  const {
    plannerData,
    setPlannerData,
    handleBlur,
    onChangeHandler,
    handleKeyPress,
    handleFocus,
  } = usePlannerContext();

  const [formData, setformData] = useState({});
  const [wmValues, setWMValues] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [age, setAge] = useState(0);

  useEffect(() => {
    if (
      plannerData &&
      typeof plannerData === "object" &&
      Object.keys(plannerData).length > 0
    ) {
      setPlannerData({
        ...plannerData,
        pay_s2_1:
          plannerData.checkboxBasicLife == "" ? "0.00" : plannerData.pay_s2_1,
      });
      const line8and2 = roundUpToNextThousand(plannerData.pay_s2_1);

      let roundedValue =
        plannerData.checkboxBasicLife == ""
          ? 0
          : convertValue(line8and2) + convertValue(plannerData["fegli_line3"]);
      let formatedValue = formatCalculatedValue(roundedValue);

      const factor = multifactor();
      let line7 = convertValue(formatedValue);

      line7 =
        convertValue(factor) &&
        convertValue(factor) * convertValue(formatedValue);

      const validateDate = moment(plannerData["dob"]);
      if (validateDate && validateDate.isValid()) {
        setAge(moment().diff(validateDate, "years", true));
      }

      const costOfOptionA =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_a_m(age)
          : get_cost_of_option_a(age);
      const costOfOptionA60 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_a_m(60)
          : get_cost_of_option_a(60);
      const costOfOptionA65 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_a_m(65)
          : get_cost_of_option_a(65);
      const costOfOptionA70 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_a_m(70)
          : get_cost_of_option_a(70);
      const costOfOptionA75 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_a_m(75)
          : get_cost_of_option_a(75);
      const costOfOptionA80 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_a_m(80)
          : get_cost_of_option_a(80);

      let basePay = convertValue(plannerData["pay_s2_1"]);
      basePay = basePay + (1000 - (basePay % 1000));
      let cost_basic_life = basePay + 2000;
      cost_basic_life = (cost_basic_life / 1000) * 0.16;
      cost_basic_life = (cost_basic_life * 26) / 12;

      if (plannerData["lite_pay_agency"] == "USPS") {
        cost_basic_life = 0.0;
      }

      const costOfOptionC =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_c(age, plannerData["selectOptionCMultiple"])
          : get_cost_of_option_c_b(age, plannerData["selectOptionCMultiple"]);
      const costOfOptionC60 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_c(60, plannerData["selectOptionCMultiple"])
          : get_cost_of_option_c_b(60, plannerData["selectOptionCMultiple"]);
      const costOfOptionC65 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_c(65, plannerData["selectOptionCMultiple"])
          : get_cost_of_option_c_b(65, plannerData["selectOptionCMultiple"]);
      const costOfOptionC70 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_c(70, plannerData["selectOptionCMultiple"])
          : get_cost_of_option_c_b(70, plannerData["selectOptionCMultiple"]);
      const costOfOptionC75 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_c(75, plannerData["selectOptionCMultiple"])
          : get_cost_of_option_c_b(75, plannerData["selectOptionCMultiple"]);
      const costOfOptionC80 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_c(80, plannerData["selectOptionCMultiple"])
          : get_cost_of_option_c_b(80, plannerData["selectOptionCMultiple"]);

      const line2 = convertValue(line8and2);
      const factor2 = convertValue(plannerData["fegli_line9"]);
      const line10 = convertValue(factor2) && convertValue(factor2) * line2;

      const age0 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_b_m(age, line10)
          : get_cost_of_option_b(age, convertValue(line10));

      const age60 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_b_m(60, line10)
          : get_cost_of_option_b(60, convertValue(line10));

      const age65 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_b_m(65, line10)
          : get_cost_of_option_b(65, convertValue(line10));

      const age70 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_b_m(70, line10)
          : get_cost_of_option_b(70, convertValue(line10));

      const age75 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_b_m(75, line10)
          : get_cost_of_option_b(75, convertValue(line10));

      const age80 =
        plannerData["wm_values"] == "1"
          ? get_cost_of_option_b_m(80, line10)
          : get_cost_of_option_b(80, convertValue(line10));

      const optionACheckbox =
        plannerData["checkboxOptionA"] === "1" ? true : false;

      let basicOptionAAmount =
        plannerData["checkboxBasicLife"] == "1"
          ? convertValue(formatedValue)
          : 0;

      basicOptionAAmount = optionACheckbox
        ? basicOptionAAmount + 10000
        : basicOptionAAmount;

      const basicOptionA = basicOptionAAmount;

      const fegli_basic_and_option_a_tomorrow = basicOptionA * 0.25;
      let fegli_s2_age_90_coverage = fegli_basic_and_option_a_tomorrow / 2;

      const optionCSpouce =
        convertValue(plannerData["selectOptionCMultiple"]) * 5000
          ? convertValue(plannerData["selectOptionCMultiple"]) * 5000
          : "0.00";
      const optionCChildren =
        convertValue(plannerData["selectOptionCMultiple"]) * 2500
          ? convertValue(plannerData["selectOptionCMultiple"]) * 2500
          : "0.00";
      const option_a = optionACheckbox ? "10,000.00" : "0.00";
      const total_life_insurance =
        convertValue(formatedValue) +
        convertValue(line7) +
        convertValue(line10) +
        convertValue(option_a);
      fegli_s2_age_90_coverage =
        fegli_s2_age_90_coverage +
        convertValue(plannerData["fegli_s2_private_sector_coverage"]);
      const payload = {
        ...plannerData,
        fegli_line4:
          plannerData["checkboxBasicLife"] == 1 ? formatedValue : "0.00",
        fegli_line2: plannerData["checkboxBasicLife"] == 1 ? line8and2 : "0.00",
        fegli_line5:
          plannerData["checkboxBasicLife"] == 1 ? formatedValue : "0.00",
        fegli_line6: factor,
        fegli_line7: formatValue(line7),
        fegli_line8: plannerData["checkboxBasicLife"] == 1 ? line8and2 : "0.00",
        fegli_line9: factor2,
        fegli_line10: formatValue(line10),
        age0OptionB: formatCalculatedValue(age0),
        age60OptionB: formatCalculatedValue(age60),
        age65OptionB: formatCalculatedValue(age65),
        age70OptionB: formatCalculatedValue(age70),
        age75OptionB: formatCalculatedValue(age75),
        age80OptionB: formatCalculatedValue(age80),
        costOfOptionA: formatCalculatedValue(costOfOptionA),
        costOfOptionA60: formatCalculatedValue(costOfOptionA60),
        costOfOptionA65: formatCalculatedValue(costOfOptionA65),
        costOfOptionA70: formatCalculatedValue(costOfOptionA70),
        costOfOptionA75: formatCalculatedValue(costOfOptionA75),
        costOfOptionA80: formatCalculatedValue(costOfOptionA80),
        costOfOptionC: formatCalculatedValue(costOfOptionC),
        costOfOptionC60: formatCalculatedValue(costOfOptionC60),
        costOfOptionC65: formatCalculatedValue(costOfOptionC65),
        costOfOptionC70: formatCalculatedValue(costOfOptionC70),
        costOfOptionC75: formatCalculatedValue(costOfOptionC75),
        costOfOptionC80: formatCalculatedValue(costOfOptionC80),
        cost_basic_life: formatCalculatedValue(cost_basic_life),
        fegli_basic_and_option_a:
          plannerData["checkboxBasicLife"] == 1
            ? formatCalculatedValue(basicOptionA)
            : "0.00",
        fegli_basic_and_option_a_tomorrow:
          plannerData["checkboxOptionA"] == 1 ||
          plannerData["checkboxBasicLife"] == 1
            ? formatCalculatedValue(fegli_basic_and_option_a_tomorrow)
            : "0.00",
        basic_life:
          plannerData["checkboxBasicLife"] == 1 ? formatedValue : "0.00",
        option_a,
        total_life_insurance:
          plannerData["checkboxBasicLife"] == 1
            ? formatCalculatedValue(total_life_insurance)
            : "0.00",
        optionCSpouce: formatCalculatedValue(optionCSpouce),
        optionCChildren: formatCalculatedValue(optionCChildren),
        fegli_s2_age_90_coverage:
          plannerData["checkboxOptionA"] == 1 ||
          plannerData["checkboxBasicLife"] == 1
            ? formatCalculatedValue(fegli_s2_age_90_coverage)
            : "0.00",
      };

      setformData(payload);
    }
  }, [
    plannerData["fegli_line2"],
    formData["fegli_line2"],
    formData["wm_values"],
  ]);

  const handleFegliCalculation = (event) => {
    if (
      event.target.name == "fegli_line6" ||
      event.target.name == "fegli_line5"
    ) {
      let multiplyValue =
        event.target.name == "fegli_line6"
          ? formData.fegli_line5
          : formData.fegli_line6;
      let value = event.target.value;
      const line7 =
        value && multiplyValue
          ? convertValue(value) * convertValue(multiplyValue)
          : "0.00";

      setformData({
        ...formData,
        fegli_line7: formatCalculatedValue(line7),

        [event.target.name]: event.target.value,
      });
    } else if (
      event.target.name == "fegli_line8" ||
      event.target.name == "fegli_line9"
    ) {
      let multiplyValue =
        event.target.name == "fegli_line8"
          ? formData.fegli_line9
          : formData.fegli_line8;
      let value = event.target.value;
      const line10 =
        value && multiplyValue
          ? convertValue(value) * convertValue(multiplyValue)
          : "0.00";

      const validateDate = moment(plannerData["dob"]);
      if (validateDate && validateDate.isValid()) {
        setAge(moment().diff(validateDate, "years", true));
      }

      const age0 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_b_m(age, formData["fegli_line10"])
          : get_cost_of_option_b(age, formData["fegli_line10"]);

      const age60 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_b_m(60, formData["fegli_line10"])
          : get_cost_of_option_b(60, formData["fegli_line10"]);

      const age65 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_b_m(65, formData["fegli_line10"])
          : get_cost_of_option_b(65, formData["fegli_line10"]);

      const age70 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_b_m(70, formData["fegli_line10"])
          : get_cost_of_option_b(70, formData["fegli_line10"]);

      const age75 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_b_m(75, formData["fegli_line10"])
          : get_cost_of_option_b(75, formData["fegli_line10"]);

      const age80 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_b_m(80, formData["fegli_line10"])
          : get_cost_of_option_b(80, formData["fegli_line10"]);

      const costOfOptionA =
        formData["wm_values"] == "1"
          ? get_cost_of_option_a_m(age)
          : get_cost_of_option_a(age);
      const costOfOptionA60 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_a_m(60)
          : get_cost_of_option_a(60);
      const costOfOptionA65 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_a_m(65)
          : get_cost_of_option_a(65);
      const costOfOptionA70 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_a_m(70)
          : get_cost_of_option_a(70);
      const costOfOptionA75 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_a_m(75)
          : get_cost_of_option_a(75);
      const costOfOptionA80 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_a_m(80)
          : get_cost_of_option_a(80);

      let basePay = convertValue(formData["pay_s2_1"]);
      basePay = basePay + (1000 - (basePay % 1000));
      let cost_basic_life = basePay + 2000;
      cost_basic_life = (cost_basic_life / 1000) * 0.16;
      cost_basic_life = (cost_basic_life * 26) / 12;

      if (formData["lite_pay_agency"] == "USPS") {
        cost_basic_life = 0.0;
      }

      const costOfOptionC =
        formData["wm_values"] == "1"
          ? get_cost_of_option_c(age, formData["selectOptionCMultiple"])
          : get_cost_of_option_c_b(age, formData["selectOptionCMultiple"]);
      const costOfOptionC60 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_c(60, formData["selectOptionCMultiple"])
          : get_cost_of_option_c_b(60, formData["selectOptionCMultiple"]);
      const costOfOptionC65 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_c(65, formData["selectOptionCMultiple"])
          : get_cost_of_option_c_b(65, formData["selectOptionCMultiple"]);
      const costOfOptionC70 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_c(70, formData["selectOptionCMultiple"])
          : get_cost_of_option_c_b(70, formData["selectOptionCMultiple"]);
      const costOfOptionC75 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_c(75, formData["selectOptionCMultiple"])
          : get_cost_of_option_c_b(75, formData["selectOptionCMultiple"]);
      const costOfOptionC80 =
        formData["wm_values"] == "1"
          ? get_cost_of_option_c(80, formData["selectOptionCMultiple"])
          : get_cost_of_option_c_b(80, formData["selectOptionCMultiple"]);

      setformData({
        ...formData,
        fegli_line10: formatCalculatedValue(line10),
        age0OptionB: formatCalculatedValue(age0),
        age60OptionB: formatCalculatedValue(age60),
        age65OptionB: formatCalculatedValue(age65),
        age70OptionB: formatCalculatedValue(age70),
        age75OptionB: formatCalculatedValue(age75),
        age80OptionB: formatCalculatedValue(age80),
        costOfOptionA: formatCalculatedValue(costOfOptionA),
        costOfOptionA60: formatCalculatedValue(costOfOptionA60),
        costOfOptionA65: formatCalculatedValue(costOfOptionA65),
        costOfOptionA70: formatCalculatedValue(costOfOptionA70),
        costOfOptionA75: formatCalculatedValue(costOfOptionA75),
        costOfOptionA80: formatCalculatedValue(costOfOptionA80),
        costOfOptionC: formatCalculatedValue(costOfOptionC),
        costOfOptionC60: formatCalculatedValue(costOfOptionC60),
        costOfOptionC65: formatCalculatedValue(costOfOptionC65),
        costOfOptionC70: formatCalculatedValue(costOfOptionC70),
        costOfOptionC75: formatCalculatedValue(costOfOptionC75),
        costOfOptionC80: formatCalculatedValue(costOfOptionC80),
        cost_basic_life: formatCalculatedValue(cost_basic_life),

        [event.target.name]: event.target.value,
      });
    } else if (event.target.name === "fegli_basic_and_option_a") {
      let fegli_basic_and_option_a_tomorrow =
        convertValue(formData["fegli_basic_and_option_a"]) * 0.25;

      setformData({
        ...formData,
        fegli_basic_and_option_a_tomorrow: formatCalculatedValue(
          fegli_basic_and_option_a_tomorrow
        ),
        [event.target.name]: event.target.value,
      });
    } else if (
      event.target.name == "fegli_basic_and_option_a_tomorrow" ||
      event.target.name == "fegli_s2_private_sector_coverage"
    ) {
      let fegli_basic_and_option_a_tomorrow =
        event.target.name == "fegli_basic_and_option_a_tomorrow"
          ? convertValue(event.target.value)
          : convertValue(formData.fegli_basic_and_option_a_tomorrow);

      let fegli_s2_private_sector_coverage =
        event.target.name == "fegli_s2_private_sector_coverage"
          ? convertValue(event.target.value)
          : convertValue(formData.fegli_s2_private_sector_coverage);

      let fegli_s2_age_90_coverage = fegli_basic_and_option_a_tomorrow / 2;

      fegli_s2_age_90_coverage =
        convertValue(fegli_s2_age_90_coverage) +
        convertValue(fegli_s2_private_sector_coverage);

      setformData({
        ...formData,
        fegli_s2_age_90_coverage: formatCalculatedValue(
          fegli_s2_age_90_coverage
        ),
        [event.target.name]: event.target.value,
      });
    }
  };

  const multifactor = () => {
    const age = parseInt(moment().diff(plannerData["dob"], "years", true));
    let multifactor = 0;
    if (age <= 35) {
      multifactor = 1.0;
    }
    if (age >= 36) {
      multifactor = 0.9;
    }
    if (age >= 37) {
      multifactor = 0.8;
    }
    if (age >= 38) {
      multifactor = 0.7;
    }
    if (age >= 39) {
      multifactor = 0.6;
    }
    if (age >= 40) {
      multifactor = 0.5;
    }
    if (age >= 41) {
      multifactor = 0.4;
    }
    if (age >= 41) {
      multifactor = 0.3;
    }
    if (age >= 43) {
      multifactor = 0.2;
    }
    if (age >= 44) {
      multifactor = 0.1;
    }
    if (age >= 45) {
      multifactor = 0;
    }
    return multifactor;
  };

  const handleOnchangeCheckbox = (e) => {
    setformData((prevState) => ({
      ...prevState,
      wm_values: e.target.value === "biweekly" ? "0" : "1",
    }));

    setPlannerData((prevState) => ({
      ...prevState,
      wm_values: e.target.value === "biweekly" ? "0" : "1",
    }));
  };

  const submitFormdata = (event) => {
    submit(event, formData);
  };

  return (
    <>
      <Card.Body className="fegli-section">
        <Form
          name="fegliForm"
          noValidate
          validated={validated}
          onSubmit={submitFormdata}
          className="employee-form"
        >
          <div
            onClick={() => setShowModal(true)}
            className="umbrella-icon c-pointer"
          >
            <i className="fa fa-umbrella"></i>
          </div>

          <FederalEmployeeCostModal
            showModal={showModal}
            setShowModal={setShowModal}
            formData={formData}
            setformData={setformData}
            handleBlur={handleBlur}
            onChangeHandler={onChangeHandler}
            handleFocus={handleFocus}
            handleKeyPress={handleKeyPress}
          />

          <div className="text-center">
            <div className="head-title text-nowrap">
              FEDERAL EMPLOYEES GROUP LIFE INSURANCE (FEGLI)
            </div>
          </div>

          <Row className="fegli-container">
            <Table className="amounts-tbl">
              <thead>
                <tr className="text-center">
                  <th style={{ border: "unset", padding: "15px 0px" }}></th>
                  <th
                    style={{ border: "unset", padding: "15px 0px" }}
                    className="main-title"
                  >
                    BASIC LIFE
                  </th>
                  <th
                    style={{ border: "unset", padding: "15px 0px" }}
                    className="main-title"
                  >
                    OPTION A
                  </th>
                  <th
                    style={{ border: "unset", padding: "15px 0px" }}
                    className="main-title"
                  >
                    OPTION B
                  </th>
                  <th
                    style={{ border: "unset", padding: "15px 0px" }}
                    className="main-title"
                  >
                    OPTION C
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="text-center">
                  <th style={{ border: "unset", padding: "10px 0px" }}>
                    Today
                  </th>
                  <td style={{ border: "1px solid #ddd", padding: "10px 0px" }}>
                    $
                    {formData["cost_basic_life"]
                      ? formData["cost_basic_life"]
                      : "0.00"}
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px 0px" }}>
                    $
                    {formData["costOfOptionA"]
                      ? formData["costOfOptionA"]
                      : "0.00"}
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px 0px" }}>
                    ${formData.age0OptionB ? formData.age0OptionB : "0.00"}
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px 0px" }}>
                    $
                    {formData["costOfOptionC"]
                      ? formData["costOfOptionC"]
                      : "0.00"}
                  </td>
                </tr>
                {age < 60 && (
                  <tr className="text-center">
                    <th style={{ border: "unset", padding: "10px 0px" }}>
                      Age 60
                    </th>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      ${"0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      $
                      {formData.costOfOptionA60
                        ? formData.costOfOptionA60
                        : "0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      ${formData.age60OptionB ? formData.age60OptionB : "0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      $
                      {formData.costOfOptionC60
                        ? formData.costOfOptionC60
                        : "0.00"}
                    </td>
                  </tr>
                )}
                {age < 65 && (
                  <tr className="text-center">
                    <th style={{ border: "unset", padding: "10px 0px" }}>
                      Age 65
                    </th>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      ${"0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      $
                      {formData.costOfOptionA65
                        ? formData.costOfOptionA65
                        : "0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      ${formData.age65OptionB ? formData.age65OptionB : "0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      $
                      {formData.costOfOptionC65
                        ? formData.costOfOptionC65
                        : "0.00"}
                    </td>
                  </tr>
                )}
                {age < 70 && (
                  <tr className="text-center">
                    <th style={{ border: "unset", padding: "10px 0px" }}>
                      Age 70
                    </th>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      ${"0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      $
                      {formData.costOfOptionA70
                        ? formData.costOfOptionA70
                        : "0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      ${formData.age70OptionB ? formData.age70OptionB : "0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      $
                      {formData.costOfOptionC70
                        ? formData.costOfOptionC70
                        : "0.00"}
                    </td>
                  </tr>
                )}
                {age < 75 && (
                  <tr className="text-center">
                    <th style={{ border: "unset", padding: "10px 0px" }}>
                      Age 75
                    </th>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      ${"0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      $
                      {formData.costOfOptionA75
                        ? formData.costOfOptionA75
                        : "0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      ${formData.age75OptionB ? formData.age75OptionB : "0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      $
                      {formData.costOfOptionC75
                        ? formData.costOfOptionC75
                        : "0.00"}
                    </td>
                  </tr>
                )}
                {age < 80 && (
                  <tr className="text-center">
                    <th style={{ border: "unset", padding: "10px 0px" }}>
                      Age 80
                    </th>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      ${"0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      $
                      {formData.costOfOptionA80
                        ? formData.costOfOptionA80
                        : "0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      ${formData.age80OptionB ? formData.age80OptionB : "0.00"}
                    </td>
                    <td
                      style={{ border: "1px solid #ddd", padding: "10px 0px" }}
                    >
                      $
                      {formData.costOfOptionC80
                        ? formData.costOfOptionC80
                        : "0.00"}
                    </td>
                  </tr>
                )}
                <tr>
                  <td style={{ borderBottom: "unset !important" }}></td>
                  <td colSpan={4} style={{ borderBottom: "unset !important" }}>
                    <div className="mt-2 wm_values_text d-flex">
                      <div className="mx-2">
                        <input
                          id="wm_valuesYes"
                          type="radio"
                          name="wm_values"
                          className={`me-1`}
                          checked={formData.wm_values == 0}
                          value={"biweekly"}
                          onChange={handleOnchangeCheckbox}
                        />{" "}
                        <label htmlFor="wm_valuesYes">Bi-weekly</label>
                      </div>
                      <div className="mx-2">
                        <input
                          id="wm_valuesNo"
                          type="radio"
                          name="wm_values"
                          className={`me-1`}
                          checked={formData.wm_values == 1}
                          value={"monthly"}
                          onChange={handleOnchangeCheckbox}
                        />{" "}
                        <label htmlFor="wm_valuesNo">Monthly</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Row>
          <div className="text-center">
            <div className="Tsp2-heading" style={{ margin: "20px 0px" }}>
              FEGLI - RETIREMENT or AGE 65
            </div>
          </div>
          <Row className="fegli-container">
            <Col md={6} className="side-section">
              <div>
                <div className="d-flex justify-content-center align-items-end">
                  <Col md={7}>
                    <div>
                      <div className="main-title">
                        <h6>Basic and Option A (TODAY)</h6>
                      </div>
                    </div>
                  </Col>
                  <Col md={5}>
                    {" "}
                    <div className="input-wrapper mt-1">
                      <b className="fers-b">$</b>
                      <Form.Control
                        autoComplete="off"
                        className="input-box fegli-Continue"
                        type="text"
                        name="fegli_basic_and_option_a"
                        value={formData.fegli_basic_and_option_a}
                        onBlur={(e) => handleBlur(e, true, setformData)}
                        onKeyPress={(e) => handleKeyPress(e)}
                        onFocus={(event) => handleFocus(event, setformData)}
                        onChange={(event) =>
                          onChangeHandler(event, setformData)
                        }
                      />
                    </div>
                  </Col>
                </div>

                <div className="sub-title">
                  <p>
                    The amount of life insurance decreases at age 65 or at
                    retirement, whichever is later, at a rate of 2% a month
                    until 25% of the amount you had at time of retirement is
                    reached. This also applies for Option A.
                  </p>
                </div>
              </div>
              <div className="mt-3">
                <div>
                  <Row className="d-flex  align-items-end">
                    <Col md={7}>
                      {" "}
                      <div
                        className="main-title "
                        style={{ textAlign: "right" }}
                      >
                        <h6>Basic and Option A (TOMORROW)</h6>
                      </div>
                    </Col>
                    <Col md={5}>
                      <div className="input-wrapper mt-1">
                        <b className="fers-b">$</b>
                        <Form.Control
                          autoComplete="off"
                          type="text"
                          className="input-box fegli-Continue"
                          name="fegli_basic_and_option_a_tomorrow"
                          value={formData.fegli_basic_and_option_a_tomorrow}
                          onBlur={(e) => handleBlur(e, true, setformData)}
                          onKeyPress={(e) => handleKeyPress(e)}
                          onFocus={(event) => handleFocus(event, setformData)}
                          onChange={(event) => handleFegliCalculation(event)}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>

                <Row className="d-flex  align-items-end">
                  <Col md={7}>
                    {" "}
                    <div className="main-title" style={{ textAlign: "right" }}>
                      <h6 style={{ color: "#000" }}>Private Sector Coverage</h6>
                    </div>
                  </Col>

                  <Col md={5}>
                    <div className="input-wrapper mt-1">
                      <b className="fers-b">$</b>
                      <Form.Control
                        autoComplete="off"
                        className="input-box fegli-Continue"
                        name="fegli_s2_private_sector_coverage"
                        type="text"
                        value={formData.fegli_s2_private_sector_coverage}
                        onBlur={(e) => handleBlur(e, true, setformData)}
                        onKeyPress={(e) => handleKeyPress(e)}
                        onFocus={(event) => handleFocus(event, setformData)}
                        onChange={(event) => handleFegliCalculation(event)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="d-flex  align-items-end mt-1">
                  <Col md={7}>
                    {" "}
                    <div className="main-title" style={{ textAlign: "right" }}>
                      <h6 style={{ color: "#08497e" }}>
                        Age 90 "Real Feel" Value *
                      </h6>
                    </div>
                  </Col>

                  <Col md={5}>
                    <div className="input-wrapper ">
                      <b className="fers-b">$</b>
                      <Form.Control
                        autoComplete="off"
                        className="input-box fegli-Continue"
                        name="fegli_s2_age_90_coverage"
                        type="text"
                        value={formData.fegli_s2_age_90_coverage}
                        onBlur={(e) => handleBlur(e, true, setformData)}
                        onKeyPress={(e) => handleKeyPress(e)}
                        onFocus={(event) => handleFocus(event, setformData)}
                        onChange={(event) =>
                          onChangeHandler(event, setformData)
                        }
                      />
                    </div>
                  </Col>
                </Row>

                <div className="sub-title">
                  <p>
                    * Real Feel Value is the projected purchase power of the
                    death benefit from Age 65 to Age 90 factoring in inflation
                    at roughly 3% annually.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={6} className="side-section">
              <Image className="dollar-image" src={Images.doller75} />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div>
                <div>
                  <div className="main-title">
                    <h6>Option B & C</h6>
                  </div>
                </div>
                <div>
                  <div className="sub-title">
                    <p>
                      At age 65 or retirement, whichever is later, an additional
                      2% reduction of the original amount per month for 50
                      months, at which point coverage ceases. You may elect to
                      continue this coverage into retirement, but at a full
                      premium which increases dramatically as you get older.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-3">
                <div>
                  <div className="main-title">
                    <h6>Retirement Options</h6>
                  </div>
                </div>
                <div>
                  <div className="sub-title">
                    <b>Basic Insurance</b>
                  </div>
                  <div className="sub-title">
                    <div>
                      <ol>
                        <li style={{ margin: 0 }}>
                          75% reduction begins at age 65, at a cost of $ 0.3467
                          per thousand per month until age 65; no cost
                          thereafter.
                        </li>
                        <li style={{ margin: 0 }}>
                          50% reduction, at a cost of $1.0967 per thousand per
                          month until age 65, $0.75 per thousand, per month
                          thereafter.
                        </li>
                        <li style={{ margin: 0 }}>
                          No reduction, at a cost of $2.5967 per thousand per
                          month until age 65, $2.25 per thousand per month
                          thereafter.
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            <Col md={6}>
              <Image className="dollar-image" src={Images.doller100} />
            </Col>
            <Col md={12}>
              <div className="mt-3 sub-title">
                <strong>Option A</strong> continues at full face amount at
                standard amount until age 65, then begins reducing at 2% per
                month until reaching 25% of face amount, at no cost.
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="mb-3 sub-title">
                <strong>Option B &amp; C</strong> If you elect Full Reduction,
                withholdings stop the month after your 65th birthday, and the
                premiums cease while face amount is reducing. If you elect No
                Reduction, withholdings for your appropriate age band continue
                after age 65 (unless you cancel coverage or change to Full
                Reduction).
              </div>
            </Col>
          </Row>
          <Row className="fegli-container">
            <Col md={4} className="mt-3 side-section">
              <div>
                <div className="main-title">
                  <h6>Total Life Insurance</h6>
                </div>
                <div className="sub-title text-nowrap d-flex flex-wrap align-items-center justify-content-between ">
                  <div>Basic Life</div>
                  <div className="input-wrapper mt-1 input-end">
                    <b>$</b>
                    <Form.Control
                      autoComplete="off"
                      className="input-box fegli-input-small"
                      type="text"
                      name="basic_life"
                      value={formData.basic_life}
                      onBlur={(e) => handleBlur(e, true, setformData)}
                      onKeyPress={(e) => handleKeyPress(e)}
                      onFocus={(event) => handleFocus(event, setformData)}
                      onChange={(event) => onChangeHandler(event, setformData)}
                    />
                  </div>
                </div>
                <div className="sub-title text-nowrap d-flex flex-wrap align-items-center justify-content-between">
                  <div>Extra Benefit</div>
                  <div className="input-wrapper mt-1 input-end">
                    <b>$</b>
                    <Form.Control
                      autoComplete="off"
                      className="input-box fegli-input-small"
                      type="text"
                      name="fegli_line7"
                      value={formData.fegli_line7}
                      onBlur={(e) => handleBlur(e, true, setformData)}
                      onKeyPress={(e) => handleKeyPress(e)}
                      onFocus={(event) => handleFocus(event, setformData)}
                      onChange={(event) => onChangeHandler(event, setformData)}
                    />
                  </div>
                </div>
                <div className="sub-title text-nowrap d-flex flex-wrap align-items-center justify-content-between">
                  <div>Option A ($10,000)</div>
                  <div className="input-wrapper mt-1 input-end">
                    <b>$</b>
                    <Form.Control
                      autoComplete="off"
                      className="input-box fegli-input-small"
                      type="text"
                      name="option_a"
                      value={formData.option_a}
                      onBlur={(e) => handleBlur(e, true, setformData)}
                      onKeyPress={(e) => handleKeyPress(e)}
                      onFocus={(event) => handleFocus(event, setformData)}
                      onChange={(event) => onChangeHandler(event, setformData)}
                    />
                  </div>
                </div>
                <div className="sub-title text-nowrap d-flex flex-wrap align-items-center justify-content-between">
                  <div>Option B - Additional</div>
                  <div className="input-wrapper mt-1 input-end">
                    <b>$</b>
                    <Form.Control
                      autoComplete="off"
                      className="input-box fegli-input-small"
                      type="text"
                      name="fegli_line10"
                      value={formData.fegli_line10}
                      onBlur={(e) => handleBlur(e, true, setformData)}
                      onKeyPress={(e) => handleKeyPress(e)}
                      onFocus={(event) => handleFocus(event, setformData)}
                      onChange={(event) => onChangeHandler(event, setformData)}
                    />
                  </div>
                </div>
                <div className="sub-title text-nowrap d-flex flex-wrap align-items-center justify-content-between">
                  <div>Total Life Insurance</div>
                  <div className="input-wrapper mt-1 input-end">
                    <b>$</b>
                    <Form.Control
                      autoComplete="off"
                      className="input-box fegli-input-small"
                      type="text"
                      name="total_life_insurance"
                      value={formData.total_life_insurance}
                      onBlur={(e) => handleBlur(e, true, setformData)}
                      onKeyPress={(e) => handleKeyPress(e)}
                      onFocus={(event) => handleFocus(event, setformData)}
                      onChange={(event) => onChangeHandler(event, setformData)}
                    />
                  </div>
                </div>
                <div className="sub-title text-nowrap d-flex flex-wrap align-items-center justify-content-between">
                  <div>Option C - Spouse</div>
                  <div className="input-wrapper mt-1 input-end">
                    <b>$</b>
                    <Form.Control
                      autoComplete="off"
                      className="input-box fegli-input-small"
                      type="text"
                      name="optionCSpouce"
                      value={formData.optionCSpouce}
                      onBlur={(e) => handleBlur(e, true, setformData)}
                      onKeyPress={(e) => handleKeyPress(e)}
                      onFocus={(event) => handleFocus(event, setformData)}
                      onChange={(event) => onChangeHandler(event, setformData)}
                    />
                  </div>
                </div>
                <div className="sub-title d-flex justify-content-between">
                  <div className="d-flex">
                    <span style={{ visibility: "hidden", width: "63px" }}>
                      Option C{" "}
                    </span>
                    <span> - Children (Under age 22 or disabled)</span>
                  </div>
                  <div className="input-wrapper mt-1 input-end">
                    <b>$</b>
                    <Form.Control
                      autoComplete="off"
                      className="input-box fegli-input-small fegli-child-input"
                      type="text"
                      name="optionCChildren"
                      value={formData.optionCChildren}
                      onBlur={(e) => handleBlur(e, true, setformData)}
                      onKeyPress={(e) => handleKeyPress(e)}
                      onFocus={(event) => handleFocus(event, setformData)}
                      onChange={(event) => onChangeHandler(event, setformData)}
                    />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={8} className="side-section">
              <div className=" p-1 mt-2" style={{ border: "1px solid #333" }}>
                <div className="main-title">
                  <h6>Notes</h6>
                </div>
                <div>
                  <Form.Text
                    className="form-text-area"
                    as="textarea"
                    name="fegli_s2_notes"
                    rows={10}
                    value={formData.fegli_s2_notes}
                    onChange={(event) => onChangeHandler(event, setformData)}
                  />
                </div>
              </div>
            </Col>
          </Row>

          <div className="btn-wrapper">
            <div className="text-center mt-4">
              <button className="btn-next btn question-next" type="submit">
                CONTINUE
              </button>
            </div>
          </div>
        </Form>
      </Card.Body>
    </>
  );
};

export default FegliForm;
